import { BellIcon as BellIconOutlined, MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { BellIcon } from '@heroicons/react/24/solid';
import React from 'react';

import styles from '../side-nav/SideNav.module.css';

export function MoonIconComponent() {
  return (
    <span className={styles.iconWrapper}>
      <MoonIcon width={16} height={16} />
    </span>
  );
}

export function SunIconComponent() {
  return (
    <span className={styles.iconWrapper}>
      <SunIcon width={16} height={16} />
    </span>
  );
}

export function BellIconComponent() {
  return (
    <span className={styles.iconWrapper}>
      <BellIcon width={16} height={16} />
    </span>
  );
}

export function EmptyBellIconComponent() {
  return (
    <span className={styles.iconWrapper}>
      <BellIconOutlined width={16} height={16} />
    </span>
  );
}

export type ItemWithIconProps = {
  Icon: React.FC;
  value: string;
};

export function ItemWithIcon({ value, Icon }: ItemWithIconProps) {
  return (
    <div className={styles.menuItemWithIcon}>
      <Icon />
      <span className={styles.itemContent}>{value}</span>
    </div>
  );
}
